import { Component, ojs, app } from "modular-openscriptjs";

const h = app("h");

export default class Loader extends Component {
	render(type, ...args) {
		return this[type](...args) ?? this.bouncer(...args);
	}

	bouncer(...args) {
		return h.div(h.div({ class: "loader" }), { class: "my-5" }, ...args);
	}

	hands(...args) {
		return h.div(
			h.div(
				{ class: "🤚" },
				h.div({ class: "👉" }),
				h.div({ class: "👉" }),
				h.div({ class: "👉" }),
				h.div({ class: "👉" }),
				h.div({ class: "🌴" }),
				h.div({ class: "👍" })
			),
			{
				class: "my-5",
			},
			...args
		);
	}

	dots(...args) {
		return h.div(
			h.figure(
				{ class: "loader-4-dots" },
				h.div({ class: "dot white" }),
				h.div({ class: "dot" }),
				h.div({ class: "dot" }),
				h.div({ class: "dot" }),
				h.div({ class: "dot" })
			),

			{
				style: "height: 100px",
			},

			...args
		);
	}
}
